/* Hot Box cart. Shopify is the source of truth for quantities and money. */
(() => {
  'use strict';
  if (typeof window.HBBoxCart?.add === 'function') return;
  const configEl = document.getElementById('HBBoxCartConfig');
  const drawer = document.getElementById('HBBoxCart');
  if (!configEl || !drawer) return;
  const config = JSON.parse(configEl.textContent);
  document.body.append(drawer);
  const $ = selector => drawer.querySelector(selector);
  const nativeFetch = window.fetch.bind(window);
  const root = (config.root || '/').replace(/\/?$/, '/');
  let cart = config.cart, queue = Promise.resolve(), opened = false, returnFocus = null;
  let savedOverflow = '', inertElements = [], category = null, externalTimer, pending = 0;
  try { category = sessionStorage.getItem('hb-latest-bag-category'); } catch (_) {}
  const escape = value => String(value == null ? '' : value).replace(/[&<>"']/g, c => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]));
  const money = cents => new Intl.NumberFormat(document.documentElement.lang || 'en-US', {style:'currency',currency:cart?.currency || config.currency || 'USD'}).format((cents || 0) / 100);
  const purchase = window.HBCartPurchase.create({config,request,money});
  function fitViewport() {
    const viewport = window.visualViewport;
    drawer.style.setProperty('--hb-cart-visible-height', (viewport?.height || window.innerHeight) + 'px');
    drawer.style.setProperty('--hb-cart-visible-top', (viewport?.offsetTop || 0) + 'px');
  }
  window.addEventListener('resize',fitViewport,{passive:true});
  window.visualViewport?.addEventListener('resize',fitViewport,{passive:true});
  window.visualViewport?.addEventListener('scroll',fitViewport,{passive:true});
  fitViewport();
  const bundle = c => (c?.items || []).filter(item => item.properties?._hb_box === '20261016');
  const bundleQty = c => bundle(c).reduce((sum,item) => sum + item.quantity, 0);
  const blocked = c => bundleQty(c) > 0 && bundleQty(c) < 4;
  const errorMessage = err => err?.message || 'We could not update your cart. Please try again.';
  const notice = message => { $('[data-hb-message]').textContent = message || ''; $('[data-hb-message]').hidden = !message; };
  function latestCategory(items) {
    for (const item of [...(items || [])].reverse()) {
      const title = (item.product_title || item.title || '').toLowerCase();
      if (/sauce|mustard|cream cheese|hot fudge|seasoning|caramel/.test(title)) continue;
      let next = null;
      if (/cinnamon|honey butter|strawberr|dubai|grape|pb\s*(?:&|and)\s*j|peanut butter.*jelly/.test(title)) next = 'sweet';
      else if (/salt|pizza|jalape|everything|bacon/.test(title)) next = 'savory';
      if (next) { category = next; try { sessionStorage.setItem('hb-latest-bag-category', next); } catch (_) {} return; }
    }
  }
  async function request(path, body) {
    const response = await nativeFetch(root + path, {method:body ? 'POST':'GET', credentials:'same-origin', cache:'no-store', headers:{Accept:'application/json',...(body && !(body instanceof FormData) ? {'Content-Type':'application/json'} : {})}, ...(body ? {body:body instanceof FormData ? body : JSON.stringify(body)} : {})});
    let data;
    try { data = await response.json(); } catch (_) { throw new Error('Connection interrupted. Review your cart before trying again.'); }
    if (!response.ok || data.status >= 400) throw new Error(data.description || data.message || 'This item could not be updated.');
    return data;
  }
  function syncCount() {
    if (window.theme) window.theme.cartItemCount = cart.item_count;
    try { const count = window.Alpine?.store('cart_count'); if (count) count.count = cart.item_count; } catch (_) {}
    document.querySelectorAll('[data-cart-count]').forEach(el => el.textContent = cart.item_count);
    document.dispatchEvent(new CustomEvent('hb:cart:updated', {detail:{cart}}));
    document.dispatchEvent(new CustomEvent('cart:updated', {detail:{cart}}));
  }
  function lineHTML(item) {
    const image = item.featured_image?.url || item.image;
    const variant = item.variant_title && item.variant_title !== 'Default Title' ? `<p class="hb-cart__variant">${escape(item.variant_title)}</p>` : '';
    const plan = item.selling_plan_allocation?.selling_plan?.name;
    const label = escape(item.product_title || item.title);
    return `<article class="hb-cart__line" data-line="${escape(item.key)}">${image ? `<a href="${escape(item.url)}" tabindex="-1" aria-hidden="true"><img class="hb-cart__line-image" src="${escape(image)}" alt="" width="82" height="100"></a>` : '<span></span>'}<div><a class="hb-cart__line-title" href="${escape(item.url)}">${label}</a>${variant}${plan ? `<p class="hb-cart__line-plan">${escape(plan)}</p>`:''}${item.properties?._hb_box === '20261016' ? '<p class="hb-cart__variant">Build Your Own Box</p>' : ''}<p class="hb-cart__line-price">${item.original_line_price > item.final_line_price ? `<s>${money(item.original_line_price)}</s>`:''}${money(item.final_line_price)}</p><div class="hb-cart__line-bottom"><div class="hb-cart__quantity" aria-label="Quantity for ${label}"><button type="button" data-hb-quantity="${item.quantity - 1}" data-key="${escape(item.key)}" aria-label="Decrease ${label} quantity">−</button><output>${item.quantity}</output><button type="button" data-hb-quantity="${item.quantity + 1}" data-key="${escape(item.key)}" aria-label="Increase ${label} quantity">+</button></div><button type="button" class="hb-cart__remove" data-hb-quantity="0" data-key="${escape(item.key)}" aria-label="Remove ${label}">Remove</button></div></div></article>`;
  }
  function render() {
    if (!cart) return;
    const focused = document.activeElement;
    const focusKey = drawer.contains(focused) && focused.dataset.key;
    const focusAction = focused?.getAttribute('aria-label');
    const focusPurchase = drawer.contains(focused) && focused.dataset.hbPurchase;
    $('[data-hb-count]').textContent = `(${cart.item_count || 0})`;
    const itemsExpanded = !!$('[data-hb-cart-details]')?.open;
    const itemsScroll = $('[data-hb-cart-lines]')?.scrollTop || 0;
    const strings = config.compactCart;
    const itemImage = cart.items?.[0]?.featured_image?.url || cart.items?.[0]?.image;
    $('[data-hb-items]').innerHTML = cart.items?.length ? `<details class="hb-cart__items-details" data-hb-cart-details ${itemsExpanded ? 'open' : ''}><summary class="hb-cart__items-summary">${itemImage ? `<img src="${escape(itemImage)}" alt="" width="56" height="56">` : ''}<span class="hb-cart__items-copy"><strong>${escape(strings.title)}</strong><span>${escape(strings.count.replace('[count]', cart.item_count))} · ${money(cart.total_price)}</span><span class="hb-cart__items-show">${escape(strings.show)}</span><span class="hb-cart__items-hide">${escape(strings.hide)}</span></span><span class="hb-cart__items-chevron" aria-hidden="true">⌄</span></summary><div class="hb-cart__items-lines" data-hb-cart-lines>${cart.items.map(lineHTML).join('')}</div></details>` : `<div class="hb-cart__empty"><h3>Your cart is empty</h3><p>Pick your favorite flavors and we'll meet you here.</p><a href="${root}collections/all">Explore all flavors</a></div>`;
    if ($('[data-hb-cart-lines]')) $('[data-hb-cart-lines]').scrollTop = itemsScroll;
    const lines = bundle(cart), qty = bundleQty(cart), total = lines.reduce((sum,item) => sum + item.final_line_price, 0);
    const original = lines.reduce((sum,item) => sum + item.original_line_price, 0);
    $('[data-hb-milestones]').hidden = !qty;
    // Box tiers (display, one-time boxes): 4-bag minimum, 5% off at 6 bags, 10% off at 8. Keep in step with the Shopify box discount.
    const bags = n => `${n} more ${n === 1 ? 'bag' : 'bags'}`;
    const step = qty < 4 ? `${bags(4-qty)} to complete your box` : qty < 6 ? `${bags(6-qty)} to save 5%` : qty < 8 ? `Saving 5% · ${bags(8-qty)} to save 10%` : 'Saving 10% on your box';
    $('[data-hb-milestones]').innerHTML = qty ? `<div class="hb-cart__milestone"><strong><span>${step}</span><span>${qty} / ${qty < 4 ? 4 : 8}</span></strong><progress value="${Math.min(qty,8)}" max="${qty < 4 ? 4 : 8}" aria-label="Box progress"></progress><p>${qty >= 4 ? `Box original ${money(original)} · Savings ${money(original-total)} · Total ${money(total)}`:'Choose any mix of at least four bags to check out.'}</p></div>` : '';
    if (!category && cart.items?.length) latestCategory([...cart.items].reverse());
    const sauces = config.sauces.filter(p => p.id);
    $('[data-hb-sauces]').hidden = !cart.items?.length || !sauces.length;
    $('[data-hb-recommendations]').innerHTML = sauces.map(p => `<article class="hb-cart__sauce">${p.image ? `<img src="${escape(p.image)}" alt="" width="52" height="65" loading="lazy">` : '<span></span>'}<div><a href="${escape(p.url)}">${escape(p.title)}</a><p>${money(p.price)}${p.available ? '' : ' · Sold out'}</p></div><button type="button" data-hb-sauce="${p.id}" ${p.available ? '' : 'disabled'} aria-label="Add ${escape(p.title)}">${p.available ? 'Add' : 'Sold out'}</button></article>`).join('');
    const purchaseHTML = purchase.html(cart);
    $('[data-hb-purchase-options]').innerHTML = purchaseHTML;
    $('[data-hb-purchase-options]').hidden = !purchaseHTML;
    if (focusPurchase) $(`[data-hb-purchase="${focusPurchase}"]`)?.focus({preventScroll:true});
    $('[data-hb-code-note]').textContent = qty ? 'Box savings apply automatically. Other discount codes cannot be combined with this box.' : '';
    $('[data-hb-discount]').classList.toggle('is-box', !!qty);
    $('[data-hb-discount] input').disabled = !!qty;
    $('[data-hb-discount] button').disabled = !!qty;
    const savings = Math.max(0,(cart.original_total_price || 0)-(cart.total_price || 0));
    $('[data-hb-totals]').innerHTML = `${savings ? `<div><dt>Original subtotal</dt><dd>${money(cart.original_total_price)}</dd></div><div><dt>Savings</dt><dd>−${money(savings)}</dd></div>` : ''}<div><dt>Subtotal</dt><dd>${money(cart.total_price)}</dd></div>`;
    $('[data-hb-checkout]').textContent = blocked(cart) ? `Add ${4-qty} more ${4-qty === 1 ? 'bag' : 'bags'} to check out` : `Checkout · ${money(cart.total_price)}`;
    $('[data-hb-checkout]').setAttribute('aria-disabled', String(blocked(cart) || !cart.item_count));
    $('[data-hb-checkout-note]').textContent = blocked(cart) ? 'Your box needs at least four bags. Add more bags or remove all box items to continue.' : cart.taxes_included ? 'Taxes included. Shipping calculated at checkout.' : 'Shipping and taxes calculated at checkout.';
    if (focusKey) {
      const replacement = [...drawer.querySelectorAll('[data-key]')].find(el => el.dataset.key === focusKey && el.getAttribute('aria-label') === focusAction);
      (replacement || $('[data-hb-cart-details] summary') || $('[data-hb-close]')).focus({preventScroll:true});
    }
    updatePageGuard();
    busyControls();
  }
  function updatePageGuard() {
    const pageCart = document.querySelector('form#cart');
    if (!pageCart) return;
    let guard = document.getElementById('HBBoxPageGuard');
    if (!guard) { guard = document.createElement('p'); guard.id = 'HBBoxPageGuard'; guard.className = 'hb-cart__page-guard'; guard.setAttribute('role','status'); pageCart.before(guard); }
    guard.hidden = !blocked(cart);
    guard.innerHTML = blocked(cart) ? `Your box has ${bundleQty(cart)} of the required 4 bags. <a href="${escape(config.builderUrl)}">Choose more flavors</a> or remove all box items before checkout.` : '';
  }
  function commit(next) { cart = next; render(); syncCount(); return cart; }
  async function refresh() { const next = await request('cart.js'); await purchase.prepare(next); return commit(next); }
  function busyControls() {
    drawer.querySelectorAll('[data-hb-quantity],[data-hb-sauce]').forEach(el => {
      const sauce = el.dataset.hbSauce && config.sauces.find(p => String(p.id) === el.dataset.hbSauce);
      el.disabled = !!(sauce && !sauce.available);
      el.setAttribute('aria-disabled',String(pending > 0 || el.disabled));
    });
  }
  function serial(task) {
    pending++; drawer.setAttribute('aria-busy','true'); busyControls();
    const next = queue.then(task);
    queue = next.catch(() => {}).finally(() => { pending--; if (!pending) drawer.removeAttribute('aria-busy'); busyControls(); });
    return next;
  }
  function reveal(trigger) {
    if (!opened) {
      opened = true; returnFocus = trigger instanceof HTMLElement ? trigger : document.activeElement;
      drawer.hidden = false; savedOverflow = document.body.style.overflow; document.body.style.overflow = 'hidden';
      inertElements = [...document.body.children].filter(el => el !== drawer && el.tagName !== 'SCRIPT' && el.tagName !== 'STYLE').map(el => [el,el.inert]);
      inertElements.forEach(([el]) => el.inert = true);
      $('[data-hb-close]').focus({preventScroll:true});
    }
    try { const modals = window.Alpine?.store('modals'); if (modals?.rightDrawer?.contents === 'cart') modals.close('cart'); } catch (_) {}
  }
  function close() {
    opened = false; drawer.hidden = true; document.body.style.overflow = savedOverflow;
    inertElements.forEach(([el,wasInert]) => el.inert = wasInert); inertElements = [];
    const target = returnFocus?.isConnected && !returnFocus.disabled ? returnFocus : document.querySelector('[data-hb-plus]:not(:disabled),#CartButton');
    target?.focus({preventScroll:true});
  }
  async function open(trigger) {
    reveal(trigger); notice('');
    if (!cart) $('[data-hb-items]').innerHTML = '<div class="hb-cart__loading" aria-label="Loading your cart"><span></span><span></span></div>';
    try { return await serial(refresh); } catch (err) { notice(errorMessage(err)); throw err; }
  }
  function add(payload,trigger) {
    return serial(async () => {
      notice('');
      const wasSubscribed = purchase.isSubscribed(cart);
      const isBox = payload instanceof FormData ? payload.get('properties[_hb_box]') === '20261016' : payload.items?.some(item => item.properties?._hb_box === '20261016');
      let clearedCodes = false;
      if (isBox) {
        const before = await request('cart.js');
        if (before.discount_codes?.length) { await request('cart/update.js',{discount:''}); clearedCodes = true; }
      }
      const response = await request('cart/add.js',payload);
      latestCategory(response.items || [response]);
      reveal(trigger);
      try { await refresh(); if (wasSubscribed && !isBox) commit(await purchase.reconcile(cart,{joinNew:true})); } catch (err) { notice('Your item was added. '+errorMessage(err)); throw err; }
      if (clearedCodes) $('[data-hb-discount] input').value = '';
      if (clearedCodes) notice('Your box uses its automatic box savings. The previous discount code was removed because these offers cannot be combined.');
      return cart;
    });
  }
  async function checkout() {
    try {
      await serial(async () => { await refresh(); commit(await purchase.reconcile(cart)); purchase.validate(cart); });
      if (blocked(cart)) { reveal(); notice('Build Your Own Box requires at least four bags. Add more flavors or remove all box items before checkout.'); return; }
      if (!cart.item_count) { reveal(); notice('Add a flavor to your cart first.'); return; }
      window.location.assign(root + 'checkout');
    } catch (err) { reveal(); notice(errorMessage(err)); }
  }
  window.HBBoxCart = {add,open,close,checkout,refresh:() => serial(refresh),reconcile:() => serial(async () => { await refresh(); return commit(await purchase.reconcile(cart)); }),getCart:() => cart};
  drawer.addEventListener('click',async event => {
    const target = event.target.closest('button,[data-hb-close]');
    if (!target) return;
    if (target.hasAttribute('data-hb-close')) { close(); return; }
    if (target.dataset.hbPurchase) {
      if (pending || target.disabled) return;
      try { await serial(async () => { notice(''); const current = await request('cart.js'); commit(await purchase.choose(target.dataset.hbPurchase,current)); }); }
      catch (err) { notice(errorMessage(err)); try { await serial(refresh); } catch (_) {} }
      return;
    }
    if (target.hasAttribute('data-hb-checkout')) { if (blocked(cart)) { notice('Choose at least four box bags to check out.'); window.location.assign(config.builderUrl); } else await checkout(); return; }
    if (target.hasAttribute('data-hb-quantity')) {
      if (target.disabled || pending) return;
      const key = target.dataset.key, quantity = Number(target.dataset.hbQuantity);
      try { await serial(async () => { notice(''); const next = await request('cart/change.js',{id:key,quantity}); commit(await purchase.reconcile(next)); }); }
      catch (err) { notice(errorMessage(err)); try { await serial(refresh); } catch (_) {} }
      finally { if (target.isConnected) target.disabled = false; }
    }
    if (target.dataset.hbSauce) {
      if (pending || target.disabled) return;
      try { await add({items:[{id:Number(target.dataset.hbSauce),quantity:1}]},target); }
      catch (err) { notice(errorMessage(err)); }
      finally { if (target.isConnected) target.disabled = false; }
    }
  });
  $('[data-hb-discount]').addEventListener('submit',async event => {
    event.preventDefault();
    if (bundleQty(cart)) { notice('Your box uses its automatic box savings. Other codes cannot be combined.'); return; }
    const input = $('[data-hb-discount] input'), code = input.value.trim();
    if (!code) { input.focus(); return; }
    try { await serial(async () => { commit(await request('cart/update.js',{discount:code})); const applied = (cart.discount_codes || []).some(d => d.code.toLowerCase() === code.toLowerCase() && d.applicable); notice(applied ? 'Discount code applied.' : 'This code is not applicable to your current cart.'); }); }
    catch (err) { notice(errorMessage(err)); }
  });
  document.addEventListener('keydown',event => {
    if (!opened) return;
    if (event.key === 'Escape') { event.preventDefault(); close(); }
    if (event.key === 'Tab') {
      const nodes = [...drawer.querySelectorAll('button:not(:disabled),a[href],input:not(:disabled),summary,[tabindex="0"]')].filter(el => el.getClientRects().length);
      if (!nodes.length) return;
      const first = nodes[0], last = nodes[nodes.length-1];
      if (event.shiftKey && (document.activeElement === first || !drawer.contains(document.activeElement))) { event.preventDefault(); last.focus(); }
      else if (!event.shiftKey && (document.activeElement === last || !drawer.contains(document.activeElement))) { event.preventDefault(); first.focus(); }
    }
  });
  // Window capture runs before legacy document-level checkout gates.
  window.addEventListener('click',event => {
    if (!bundleQty(cart)) return;
    const target = event.target.closest('button[name=checkout],input[name=checkout],a[href],[data-checkout-button]');
    if (!target || drawer.contains(target)) return;
    let isCheckout = target.name === 'checkout' || target.hasAttribute('data-checkout-button');
    try { const u = new URL(target.href,location.href); isCheckout = isCheckout || (u.origin === location.origin && /\/checkout\/?$/.test(u.pathname)); } catch (_) {}
    if (!isCheckout) return;
    event.preventDefault(); event.stopImmediatePropagation(); checkout();
  },true);
  document.addEventListener('click',event => {
    const target = event.target.closest('a,button,input');
    if (!target || drawer.contains(target) || event.button > 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    let url; try { if (target.href) url = new URL(target.href,location.href); } catch (_) {}
    const sameOrigin = url && url.origin === location.origin;
    if (target.id === 'CartButton' || target.hasAttribute('data-hb-open-cart') || (sameOrigin && /^\/(?:[a-z]{2}(?:-[A-Z]{2})?\/)?cart\/?$/.test(url.pathname))) {
      event.preventDefault(); event.stopImmediatePropagation(); open(target).catch(() => {});
    } else if (target.name === 'checkout' || (sameOrigin && /\/checkout\/?$/.test(url.pathname))) {
      if (event.defaultPrevented) return;
      event.preventDefault(); event.stopImmediatePropagation(); checkout();
    }
  },true);
  document.addEventListener('submit',event => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement) || drawer.contains(form)) return;
    const url = new URL(form.action,location.href);
    if (url.origin !== location.origin) return;
    if (/\/cart\/add(?:\.js)?\/?$/.test(url.pathname)) {
      event.preventDefault(); event.stopImmediatePropagation();
      const trigger = event.submitter || form.querySelector('[type=submit]');
      if (form.dataset.hbAdding) return;
      const data = new FormData(form); form.dataset.hbAdding = 'true'; if (trigger) trigger.disabled = true;
      add(data,trigger).catch(err => { reveal(trigger); notice(errorMessage(err)); }).finally(() => { delete form.dataset.hbAdding; if (trigger) trigger.disabled = false; });
    } else if (event.submitter?.name === 'checkout' || /\/checkout\/?$/.test(url.pathname)) {
      event.preventDefault(); event.stopImmediatePropagation(); checkout();
    }
  },true);
  // Observe successful additions from apps that use the Ajax API directly.
  function externalSuccess(url,response,trigger) {
    let path; try { const parsed = new URL(url,location.href); if (parsed.origin !== location.origin) return; path = parsed.pathname; } catch (_) { return; }
    if (/\/cart\/add(?:\.js)?$/.test(path)) {
      if (response) latestCategory(response.items || [response]); reveal(trigger);
      clearTimeout(externalTimer); externalTimer = setTimeout(() => serial(refresh).catch(err => notice(errorMessage(err))),80);
    } else if (/\/cart\/(?:change|update|clear)(?:\.js)?$/.test(path)) {
      clearTimeout(externalTimer); externalTimer = setTimeout(() => serial(refresh).catch(() => {}),80);
    }
  }
  window.fetch = function(input,init) {
    const trigger = document.activeElement, url = typeof input === 'string' ? input : input?.url;
    return nativeFetch(input,init).then(response => {
      if (response.ok && /\/cart\/(?:add|change|update|clear)(?:\.js)?(?:\?|$)/.test(url || '')) response.clone().json().then(data => { if (!(data.status >= 400)) externalSuccess(url,data,trigger); }).catch(() => {});
      return response;
    });
  };
  const xhrOpen = XMLHttpRequest.prototype.open, xhrSend = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.open = function(method,url,...args) { this.__hbURL = url; return xhrOpen.call(this,method,url,...args); };
  XMLHttpRequest.prototype.send = function(...args) {
    const trigger = document.activeElement;
    if (/\/cart\/(?:add|change|update|clear)/.test(this.__hbURL || '')) this.addEventListener('load',() => {
      if (this.status >= 200 && this.status < 300) { let result; try { result = this.responseType === 'json' ? this.response : JSON.parse(this.responseText); } catch (_) {} if (!(result?.status >= 400)) externalSuccess(this.__hbURL,result,trigger); }
    },{once:true});
    return xhrSend.apply(this,args);
  };
  window.addEventListener('pageshow',() => serial(refresh).catch(() => {}));
  render();
})();
